export type MismatchedCity = {
  flight_idx: number;
  offered_airport: string;
  original_search: string;
};

export type MismatchedCityWithDistance = MismatchedCity & {
  distance: number;
};

export type MismatchedCityNames = {
  distance: number;
  original: string;
  offered: string;
};
